module.exports = __webpack_public_path__ + "static/media/place.5d501020.svg";